import { Rad2Deg } from "./MathEx.js";
import { Quaternion } from "./Quaternion.js";
import { Vector3 } from "./Vector3.js";
export const azimuth = (position, observerRot) => {
    const v = Quaternion.Inverse(observerRot).multiply(position);
    return Math.atan2(v.x, v.z) * Rad2Deg;
};
export const altitude = (position, observerUp) => {
    return 90 - Vector3.Angle(position, observerUp) * Rad2Deg;
};
